module.exports = "/fonts/nucleo.woff?f0b489a5dbbff08833d21024f9fcbd4e";